'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userComplete = userComplete;
exports.hideUserCompletePrompt = hideUserCompletePrompt;
exports.setPassengerIdForFlightCheck = setPassengerIdForFlightCheck;
exports.setIsZeroScheduleFlow = setIsZeroScheduleFlow;
var USER_COMPLETE = exports.USER_COMPLETE = 'USER_COMPLETE';
var HIDE_USER_COMPLETE_PROMPT = exports.HIDE_USER_COMPLETE_PROMPT = 'HIDE_USER_COMPLETE_PROMPT';
var CURRENT_FLIGHT_CHECK_PASSENGER = exports.CURRENT_FLIGHT_CHECK_PASSENGER = "CURRENT_FLIGHT_CHECK_PASSENGER";
var IS_ZERO_SCHEDULE_FLOW = exports.IS_ZERO_SCHEDULE_FLOW = "IS_ZERO_SCHEDULE_FLOW";

// This action is fired when a user completes her G2G
// (See: /app/components/UserComplete.js)
function userComplete() {
    return {
        type: USER_COMPLETE
    };
}

// This action is fired when a user dismisses the `UserComplete` modal
// It sets user.prompt to false in redux
function hideUserCompletePrompt() {
    return {
        type: HIDE_USER_COMPLETE_PROMPT
    };
}

function setPassengerIdForFlightCheck(flightCheckPassengerId) {
    return {
        type: CURRENT_FLIGHT_CHECK_PASSENGER,
        flightCheckPassengerId: flightCheckPassengerId
    };
}

function setIsZeroScheduleFlow(isZeroScheduleFlow) {
    return {
        type: IS_ZERO_SCHEDULE_FLOW,
        isZeroScheduleFlow: isZeroScheduleFlow
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/userActions.js
// module id = 206
// module chunks = 0